<template>
    <div>
        <el-form :inline="true" :model="searchForm" class="forTbFilter" @submit.native.prevent label-position="left">
            <el-form-item label="代理商：">
                <el-select v-model="searchForm.agentId" @change="getPkgSoldListPageHandle" filterable>
                    <el-option v-for="item in agentListOption" :value="item.id" :key="item.id" :label="item.name+'（'+item.sysUserAccountName+'）'"></el-option>
                </el-select>
            </el-form-item>
           <el-form-item label="分配状态：">
                <el-select v-model="searchForm.state">
                    <el-option value="1" label="已分配"></el-option>
                    <el-option value="0" label="未分配"></el-option>
                </el-select>
            </el-form-item>
           
            <el-form-item label="套餐组名称：">
                <el-select v-model="searchForm.pkgGroupId" clearable filterable>
                    <el-option v-for="item in pkgGroup" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="套餐名称：">
                <el-input  v-model="searchForm.packageName" clearable></el-input>
            </el-form-item>

            <el-form-item >
                <el-button type="primary" plain icon="el-icon-search" @click="getPkgSoldListPageHandle">查询</el-button>
                <el-button type="success" plain icon="el-icon-s-ticket" @click="batchAddSoldPkg()">批量分销</el-button>
            </el-form-item>

        </el-form>

        <el-table :data="tbpg.tableData" border
		fit
		highlight-current-row
		style="width: 100%;"
		:header-cell-style="{background:'#f5f5f5'}"  >
            <el-table-column prop="pkgGroupName" label="套餐组名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="packageName" label="套餐名称" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="packageTypeName" label="套餐类型" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="verifyPriceRmb" label="套餐成本价（元）" align="center" show-overflow-tooltip></el-table-column>
            <el-table-column prop="salePriceRmb" label="套餐金额（元）" align="center" show-overflow-tooltip></el-table-column>  
            <el-table-column label="分销比例">
                <template slot-scope="scope">                    
                    <el-input v-if="scope.row.soldState==1" type="number" v-model="scope.row.soldPercent" :value="scope.row.soldPercent" @change="updateSoldPercentHandle(scope.row)"></el-input>
                    <span v-else>{{ scope.row.soldPercent }}</span>
                </template>                 
            </el-table-column>              
             <el-table-column label="分销价格（元）"  align="center" show-overflow-tooltip>
                <template slot-scope="scope">                    
                    <el-input v-if="scope.row.soldState==1" type="number" v-model="scope.row.soldPriceRmb" :value="scope.row.soldPriceRmb" @change="updateSoldPercentHandle1(scope.row)"></el-input>
                    <span v-else>{{ scope.row.soldPriceRmb }}</span>
                </template>                 
            </el-table-column>
            <el-table-column prop="soldStateName"  align="center" show-overflow-tooltip label="状态" sortable></el-table-column>
             <el-table-column prop="name"  align="center" show-overflow-tooltip label="分配人" sortable></el-table-column>
            <el-table-column label="操作" align="center" fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="pkgDistributHandle(scope.row)">{{showbtnText(scope.row.soldState)}}</el-button>
                </template>                  
            </el-table-column>
        </el-table>
                  
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
			background
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination> 


        
           <el-dialog :append-to-body="true"  title="设置分销比例" :visible.sync="soldBoolan" width="600px" @close="cancel" :close-on-click-modal="false">
            <el-form ref="searchForm" :model="searchForm" label-width="120px">
                 <el-form-item label="分销比例：">
                <el-input v-model.trim="searchForm.soldData" placeholder="分销百分比" clearable></el-input>
            </el-form-item>
            <p style="color:red">备注：请合理设置分销比列 分销后价格不能低于成本价，否则会分销失败</p>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button type="primary" @click="soldAuth()">确 定</el-button>
            </div>
        </el-dialog>       
    </div>
</template>
<script>
import {getPkgSoldListPage, pkgDistribut, pkgDistributCancel, updateSoldPercent,updateSoldPercent1} from '@/api/package.js'
import common from '@/utils/common.js'
export default {
    data(){
        return {
            soldBoolan:false,
            searchForm: {
                pkgGroupId: '',
                state:'',
                agentId: '',
                soldState: '',
                supplierType: '',
                packageName: ''
            },
            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0
            },    
            pkgGroup: [ ],  
            soldStateGroup:[
                   {
                    code:0,
                    description:'未分销'
                },
                {
                    code:1,
                    description:'已分销'
                }
            ],      
            agentListOption: [],
            supplierOption: [],
            title: ''
        }
    },
    methods: {
        showbtnText(state){
            return common.showTxtByState(state, {0: '分销', 1: '移除'})
        },        
        getPkgSoldListPageHandle($event){
            // if(this.searchForm.agentId === ''){
            //     this.$message.error("请先选择代理商");
            //     return;               
            // }

            common.resetCurrentPage(this, $event, 'tbpg');
            var data = common.getRequestParams(this, 'tbpg', this.searchForm);
            getPkgSoldListPage(data).then(res => {
                common.listCallback(this, res, 'tbpg');
            })
        },
        pkgDistributHandle(row){
            var data = {
                packageId: row.packageId,
                agentId: this.searchForm.agentId
            }
            if(row.soldState == 1){
                data.nextId = row.nextId;
                pkgDistributCancel(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getPkgSoldListPageHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }else{
                pkgDistribut(data).then(res => {
                    if(res.data.code == 200){
                        this.$message.success(res.data.message);
                        this.getPkgSoldListPageHandle();
                    }else{
                        this.$message.error(res.data.message);
                    }
                })
            }
        },
        updateSoldPercentHandle1(row){            
            var data = {
                id: row.id,
                nextId: row.nextId,
                soldPercent: row.soldPriceRmb
            }
            updateSoldPercent1(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);                    
                }else{
                    this.$message.error(res.data.message);
                }
                this.getPkgSoldListPageHandle();
            })

        },
         updateSoldPercentHandle(row){            
            var data = {
                id: row.id,
                nextId: row.nextId,
                soldPercent: row.soldPercent
            }
            updateSoldPercent(data).then(res => {
                if(res.data.code == 200){
                    this.$message.success(res.data.message);                    
                }else{
                    this.$message.error(res.data.message);
                }
                this.getPkgSoldListPageHandle();
            })

        },
        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getPkgSoldListPageHandle();
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getPkgSoldListPageHandle();
        },

        
           
            soldAuth(){
                 if(this.searchForm.agentId==null||this.searchForm.agentId==''){
                this.$message.error('请选择代理商！');
                return;
            }
             if(this.searchForm.pkgGroupId==null||this.searchForm.pkgGroupId==''){
                this.$message.error('请选择套餐组！');
                return;
            }
             if(this.searchForm.soldData==null||this.searchForm.soldData==''){
                this.$message.error('请输入分销比例！');
                return;
            }
            let data = {
                agentId: this.searchForm.agentId,
                soldData:this.searchForm.soldData,
                pkgGroupIds: [this.searchForm.pkgGroupId],
            };

            common.sysRequest('pkg/sold/batchAddSoldPkg', data, 'post').then(res => {
                if(res.data.code == 200){
                    this.$message.success('操作分销成功，具体操作结果请点击 搜索 查询！'); 
                    this.soldBoolan=false;  
                    this.getPkgSoldListPageHandle();                 
                }else{
                    this.$message.error(res.data.message);
                }
                this.getAgentPkgSoldListPageHandle();
            });
        },
        batchAddSoldPkg(){
             if(this.searchForm.agentId==null||this.searchForm.agentId==''){
                this.$message.error('请选择代理商！');
                return;
            }
             if(this.searchForm.pkgGroupId==null||this.searchForm.pkgGroupId==''){
                this.$message.error('请选择套餐组！');
                return;
            }
            this.soldBoolan=true;          
        }       ,
          cancel(){
            this.soldBoolan=false
        },     
    },
    created(){
        common.getAgentListOptionCom(this, 'agentListOption');
        common.getSupplierOptionCom(this, 'supplierOption');
        common.getPkgGroupListCom(this, 'pkgGroup');
        this.getPkgSoldListPageHandle();
    }
}
</script>
<style lang="less">

</style>

